import { FC, Fragment } from 'react';

interface Props {
  text: string;
}

export const RepairLineBreaks: FC<Props> = ({ text }) => {
  const lines = text.replaceAll('\r\n', '\n').replaceAll('\r', '\n').split('\n');
  return (
    <>
      {lines.map((x, i) => (
        <Fragment key={i}>
          {x}
          {i < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
};
